function initRebuyFbtProgress() {
  const widget = document.querySelector("#rebuy-widget-224481");

  if (!widget || widget.dataset.progressReady === "true") return;

  const track = widget.querySelector(".splide__track");
  const list = widget.querySelector(".splide__list");
  const content = widget.querySelector(".rebuy-widget-content");

  if (!track || !list || !content) return;

  const progress = document.createElement("div");
  progress.className = "as-rebuy-fbt-progress";
  progress.innerHTML = "<span></span>";

  content.appendChild(progress);

  const fill = progress.querySelector("span");

  const update = () => {
    const max = list.scrollWidth - track.clientWidth;
    const current = Math.abs(
      parseFloat(list.style.transform.replace(/[^\d.-]/g, "")) || 0,
    );

    const percent = max > 0 ? Math.min(current / max, 1) : 0;

    fill.style.width = "45%";
    fill.style.transform = `translateX(${percent * 122}%)`;
  };

  update();

  const observer = new MutationObserver(update);

  observer.observe(list, {
    attributes: true,
    attributeFilter: ["style"],
  });

  widget.dataset.progressReady = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFbtProgress();

  setTimeout(initRebuyFbtProgress, 500);
  setTimeout(initRebuyFbtProgress, 1000);
  setTimeout(initRebuyFbtProgress, 2000);
  setTimeout(initRebuyFbtProgress, 4000);
});

document.addEventListener("rebuy:cart.show", initRebuyFbtProgress);
document.addEventListener("rebuy:cart.change", initRebuyFbtProgress);

function initRebuyFbtHeader() {
  const widget = document.querySelector("#rebuy-widget-224481");

  if (!widget || widget.dataset.headerReady === "true") return;

  const title = widget.querySelector(".primary-title");
  const content = widget.querySelector(".rebuy-widget-content");

  if (!title || !content) return;

  const wrapper = document.createElement("div");
  wrapper.className = "as-rebuy-fbt-header";

  const subtitle = document.createElement("p");
  subtitle.className = "as-rebuy-fbt-subtitle";
  subtitle.innerHTML = "Get the most our of your FREE shipping";

  title.parentNode.insertBefore(wrapper, title);

  wrapper.appendChild(title);
  wrapper.appendChild(subtitle);

  widget.dataset.headerReady = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFbtHeader();

  setTimeout(initRebuyFbtHeader, 500);
  setTimeout(initRebuyFbtHeader, 1000);
  setTimeout(initRebuyFbtHeader, 2000);
});

document.addEventListener("rebuy:cart.show", initRebuyFbtHeader);
document.addEventListener("rebuy:cart.change", initRebuyFbtHeader);

function syncRebuyCartInertState() {
  const cart = document.querySelector("#rebuy-cart");

  if (!cart) return;

  const isHidden =
    cart.getAttribute("aria-hidden") === "true" ||
    cart.hidden ||
    cart.classList.contains("is-hidden");

  if (isHidden) {
    cart.setAttribute("inert", "");
  } else {
    cart.removeAttribute("inert");

    /*
     * Remove tabindex="-1" left by the previous accessibility script.
     * Only reset native interactive elements inside the open cart.
     */
    cart
      .querySelectorAll(
        "a[href][data-rebuy-old-tabindex], button[data-rebuy-old-tabindex], input[data-rebuy-old-tabindex], select[data-rebuy-old-tabindex], textarea[data-rebuy-old-tabindex]",
      )
      .forEach((element) => {
        const oldTabindex = element.getAttribute("data-rebuy-old-tabindex");

        if (oldTabindex) {
          element.setAttribute("tabindex", oldTabindex);
        } else {
          element.removeAttribute("tabindex");
        }

        element.removeAttribute("data-rebuy-old-tabindex");
      });
  }
}

syncRebuyCartInertState();

document.addEventListener("rebuy:cart.show", function () {
  requestAnimationFrame(function () {
    requestAnimationFrame(syncRebuyCartInertState);
  });
});

document.addEventListener("rebuy:cart.hide", syncRebuyCartInertState);
document.addEventListener("rebuy:cart.change", syncRebuyCartInertState);

function updateProgressTitleLines() {
  const title = document.querySelector("#rebuy-cart__progress-bar-meter-label");
  const progress = document.querySelector(".as-rebuy-progress");

  if (!title || !progress) return;

  const styles = getComputedStyle(title);
  const lineHeight = parseFloat(styles.lineHeight);

  if (!lineHeight) return;

  const isTwoLines = title.getBoundingClientRect().height > lineHeight * 1.5;

  progress.classList.toggle("as-rebuy-progress--two-lines", isTwoLines);
}

updateProgressTitleLines();

window.addEventListener("resize", updateProgressTitleLines);

/*
 * Free Gift controls
 *
 * Rebuy's Tiered Progress Bar remembers when a customer manually removes
 * a free gift and does not automatically add it back again.
 *
 * To prevent that state, hide the remove button and quantity controls
 * for items identified as Tiered Progress Bar free gifts.
 */
function updateRebuyFreeGiftControls() {
  const cartItems = document.querySelectorAll(
    "#rebuy-cart .rebuy-cart__flyout-item",
  );

  cartItems.forEach((item) => {
    const discountMessage = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message",
    );

    const discountText =
      discountMessage?.textContent?.trim().toLowerCase() || "";

    const isFreeGift = discountText === "free gift";

    const isTieredProgressItem =
      item.classList.contains("property-value-rebuy-tiered-progress-bar") ||
      Array.from(item.classList).some((className) =>
        className.includes("rebuy-tiered-progress-bar"),
      );

    /*
     * Require both checks so another discounted product
     * is not accidentally treated as a free gift.
     */
    if (!isFreeGift || !isTieredProgressItem) return;

    item.classList.add("as-rebuy-free-gift");
    const itemInfo = item.querySelector(".rebuy-cart__flyout-item-info");

    if (itemInfo) {
      itemInfo.style.setProperty("justify-content", "flex-start", "important");
    }

    const discountMessageElement = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message",
    );

    if (discountMessageElement) {
      discountMessageElement.style.setProperty(
        "margin-top",
        "4px",
        "important",
      );

      discountMessageElement.style.setProperty(
        "margin-bottom",
        "4px",
        "important",
      );
    }

    const removeButton = item.querySelector(".rebuy-cart__flyout-item-remove");

    if (removeButton) {
      removeButton.style.setProperty("display", "none", "important");
      removeButton.setAttribute("aria-hidden", "true");
      removeButton.setAttribute("tabindex", "-1");
    }

    const quantityContainer = item.querySelector(
      ".rebuy-cart__flyout-item-quantity",
    );

    if (quantityContainer) {
      quantityContainer.style.setProperty("display", "none", "important");
      quantityContainer.setAttribute("aria-hidden", "true");
    }
  });
}

function initRebuyFreeGiftControls() {
  requestAnimationFrame(() => {
    requestAnimationFrame(updateRebuyFreeGiftControls);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFreeGiftControls();

  setTimeout(initRebuyFreeGiftControls, 500);
  setTimeout(initRebuyFreeGiftControls, 1000);
  setTimeout(initRebuyFreeGiftControls, 2000);
});

document.addEventListener("rebuy:cart.show", initRebuyFreeGiftControls);

document.addEventListener("rebuy:cart.change", initRebuyFreeGiftControls);

/*
 * Keeping the tweaks above applied as Rebuy re-renders its cart.
 *
 * Rebuy mounts #rebuy-cart (a direct child of <body>) after this deferred
 * script runs and re-renders its contents on every cart update, including the
 * frequently-bought-together widget. So the cart itself is watched, and <body>
 * only for its direct children until the cart appears. This replaces two
 * setInterval(…, 1000) polls and a page-wide observer, which was also handed
 * every attribute change the review widgets make while loading (~90,000 on the
 * home page).
 */
let observedRebuyCart = null;
let rebuyCartWorkScheduled = false;

function onRebuyCartMutation() {
  if (rebuyCartWorkScheduled) return;
  rebuyCartWorkScheduled = true;

  requestAnimationFrame(() => {
    rebuyCartWorkScheduled = false;
    syncRebuyCartInertState();
    updateProgressTitleLines();
    updateRebuyFreeGiftControls();
    initRebuyFbtProgress();
    initRebuyFbtHeader();
  });
}

// The cart's own open/closed state.
const rebuyCartStateObserver = new MutationObserver(onRebuyCartMutation);
// Its rendered contents (items, progress label, widgets).
const rebuyCartContentObserver = new MutationObserver(onRebuyCartMutation);

function attachRebuyCartObservers() {
  const cart = document.querySelector("#rebuy-cart");
  if (!cart || cart === observedRebuyCart) return;

  observedRebuyCart = cart;
  rebuyCartStateObserver.disconnect();
  rebuyCartContentObserver.disconnect();

  rebuyCartStateObserver.observe(cart, {
    attributes: true,
    attributeFilter: ["aria-hidden", "class", "hidden"],
  });

  rebuyCartContentObserver.observe(cart, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  onRebuyCartMutation();
}

attachRebuyCartObservers();

new MutationObserver(attachRebuyCartObservers).observe(document.body, {
  childList: true,
});
